import React from "react";
import { cn } from "../../lib/utils";
import { REGIONAL_BRIEFS } from "../../lib/constants";

export function RegionalNav({ className }) {
  return (
    <nav
      className={cn(
        "bg-paper-dark/50",
        "border-b border-border",
        "py-3 px-4",
        className
      )}
      aria-label="Regional newsletter navigation"
    >
      <div className="max-w-4xl mx-auto">
        {/* Scrollable container for mobile */}
        <div className="flex items-center justify-center gap-1 md:gap-2 overflow-x-auto scrollbar-hide">
          {REGIONAL_BRIEFS.map((brief, index) => (
            <a
              key={brief.id}
              href={brief.href}
              className={cn(
                "relative px-4 py-2",
                "font-sans text-sm font-medium whitespace-nowrap",
                "transition-all duration-300",
                "rounded-sm",
                // Animation
                "animate-on-load animate-fade-in-up",
                // Active state
                brief.active
                  ? [
                      "text-gold",
                      "bg-gold/10",
                      // Gold underline for active
                      "after:absolute after:bottom-0 after:left-2 after:right-2",
                      "after:h-0.5 after:bg-gold",
                    ]
                  : [
                      "text-ink-muted",
                      "hover:text-ink hover:bg-paper-dark",
                      // Underline draw on hover
                      "after:absolute after:bottom-0 after:left-2 after:right-2",
                      "after:h-0.5 after:bg-gold after:scale-x-0",
                      "after:transition-transform after:duration-300",
                      "hover:after:scale-x-100",
                    ],
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold"
              )}
              style={{ animationDelay: `${0.3 + index * 0.1}s` }}
              aria-current={brief.active ? "page" : undefined}
            >
              {brief.name}
              {brief.active && (
                <span className="sr-only"> (current region)</span>
              )}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
}
